function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.6057 22.3105C24.4057 22.3105 22.8057 20.2105 22.2057 19.5105C20.9057 17.8105 19.3057 17.3105 15.6057 17.3105C11.8057 17.3105 10.2057 17.8105 8.90574 19.5105C7.70574 21.0105 5.80574 23.0105 3.30574 22.1105C0.605738 21.2105 -0.0942617 17.1105 1.30574 10.6105C2.60574 4.61055 4.60574 1.41055 7.50574 0.610547C8.20574 0.410547 8.80574 0.310547 9.50574 0.310547C10.4057 0.310547 11.1057 0.510547 11.9057 0.710547C12.9057 1.01055 13.9057 1.31055 15.5057 1.31055C17.1057 1.31055 18.2057 1.01055 19.1057 0.710547C19.9057 0.510547 20.7057 0.310547 21.5057 0.310547C22.1057 0.310547 22.8057 0.410547 23.4057 0.610547C26.4057 1.51055 28.4057 4.71055 29.7057 10.7105C30.7057 15.0105 31.5057 20.9105 27.7057 22.2105C27.3057 22.2105 26.9057 22.3105 26.6057 22.3105ZM15.5057 15.3105C19.3057 15.3105 21.7057 15.8105 23.7057 18.2105C25.7057 20.7105 26.7057 20.3105 27.1057 20.2105C28.7057 19.6105 29.0057 16.5105 27.8057 11.0105C26.7057 5.91055 25.1057 3.11055 22.9057 2.41055C22.5057 2.31055 22.0057 2.21055 21.6057 2.21055C21.0057 2.21055 20.5057 2.41055 19.7057 2.61055C18.7057 2.91055 17.4057 3.21055 15.6057 3.21055C13.8057 3.21055 12.5057 2.81055 11.5057 2.61055C10.8057 2.41055 10.2057 2.31055 9.60574 2.21055C9.00574 2.31055 8.50574 2.41055 8.10574 2.51055C6.00574 3.11055 4.40574 5.91055 3.20574 11.1105C2.10574 16.1105 2.40574 19.7105 3.90574 20.2105C4.50574 20.4105 5.50574 20.4105 7.20574 18.2105C9.20574 15.8105 11.7057 15.3105 15.5057 15.3105Z",
  fill: "black"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.8057 10.6098C18.5057 10.6098 19.1057 10.0098 19.1057 9.30977C19.1057 8.60977 18.5057 8.00977 17.8057 8.00977C17.1057 8.00977 16.5057 8.60977 16.5057 9.30977C16.5057 10.0098 17.1057 10.6098 17.8057 10.6098Z",
  fill: "black"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.5057 13.3102C20.3057 13.3102 20.0057 13.2102 19.8057 13.1102C19.6057 13.0102 19.4057 12.8102 19.3057 12.5102C19.2057 12.3102 19.2057 12.0102 19.2057 11.8102C19.2057 11.6102 19.4057 11.3102 19.5057 11.2102C19.7057 11.0102 19.9057 10.9102 20.1057 10.9102C20.3057 10.9102 20.6057 10.9102 20.8057 11.0102C21.0057 11.1102 21.2057 11.3102 21.4057 11.5102C21.5057 11.7102 21.6057 11.9102 21.6057 12.2102C21.6057 12.5102 21.5057 12.8102 21.2057 13.1102C21.1057 13.2102 20.8057 13.3102 20.5057 13.3102Z",
  fill: "black"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.5057 7.81094C21.2057 7.81094 21.8057 7.21094 21.8057 6.51094C21.8057 5.81094 21.2057 5.21094 20.5057 5.21094C19.8057 5.21094 19.2057 5.81094 19.2057 6.51094C19.2057 7.21094 19.8057 7.81094 20.5057 7.81094Z",
  fill: "black"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.3057 10.6098C24.0057 10.6098 24.6057 10.0098 24.6057 9.30977C24.6057 8.60977 24.0057 8.00977 23.3057 8.00977C22.6057 8.00977 22.0057 8.60977 22.0057 9.30977C22.0057 10.0098 22.6057 10.6098 23.3057 10.6098Z",
  fill: "black"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.5057 6.31055C10.5057 5.71055 10.1057 5.31055 9.50574 5.31055C8.90574 5.31055 8.50574 5.71055 8.50574 6.31055V8.31055H6.50574C5.90574 8.31055 5.50574 8.71055 5.50574 9.31055C5.50574 9.91055 5.90574 10.3105 6.50574 10.3105H8.50574V12.3105C8.50574 12.9105 8.90574 13.3105 9.50574 13.3105C10.1057 13.3105 10.5057 12.9105 10.5057 12.3105V10.3105H12.5057C13.1057 10.3105 13.5057 9.91055 13.5057 9.31055C13.5057 8.71055 13.1057 8.31055 12.5057 8.31055H10.5057V6.31055Z",
  fill: "black"
});

var SvgGame = function SvgGame(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGame, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/game.f46f8808.svg";
export { ForwardRef as ReactComponent };